import React, { Component } from 'react'
import Map from './Map'
import SearchInput from './SearchInput'
import StoreList from './StoreList'
import { parseQuery } from '../helpers/query'
import styles from '../styles/template.module.css'
import * as copy from '../text_data/template.json'

class Template extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isAccessible: false,
      google: null,
      stores: [],
      allStores: [],
      selectedStore: null,
      highlightedStores: [],
      isSearching: false,
      searchEnabled: true,
      searchResult: null
    }

    this.lang = window.location.pathname.indexOf('/fr/') > -1 ? `fr` : `en`

    this.toggleAccessibility = this.toggleAccessibility.bind(this)
    this.updateStores = this.updateStores.bind(this)
    this.selectStore = this.selectStore.bind(this)
    this.highlightStores = this.highlightStores.bind(this)
    this.searchCurrentLocation = this.searchCurrentLocation.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.enableSearch = this.enableSearch.bind(this)
  }

  componentDidMount () {
    window.addEventListener('keyup', this.toggleAccessibility)
    window.addEventListener('mousedown', this.toggleAccessibility)

    var http = new XMLHttpRequest()
    http.open('GET', '/wp-content/uploads/locations/data.json')
    http.onreadystatechange = function () {
      if (http.readyState == 4 && http.status == "200") {
        this.setState({
          allStores: JSON.parse(http.responseText)
        }, () => {
          // Get location param to search
          const query = parseQuery(window.location.search)
          this.initMap(query)
        })
      }
    }.bind(this)
    http.send(null)
  }

  componentWillUnmount () {
    window.removeEventListener('keyup', this.toggleAccessibility)
    window.removeEventListener('mousedown', this.toggleAccessibility)
  }

  toggleAccessibility (e) {
    if (e.type === 'mousedown') {
      this.setState({isAccessible: false})
    } else if (e.keyCode === 9) {
      this.setState({isAccessible: true})      
    }
  }

  initMap (query) {
    this.mapAPIisReady().then((google) => {
      this.setState({ google })
      this.geocoder = new google.maps.Geocoder()

      if (query.location) {
        this.searchLocation(query.location)
      } else if (window.matchMedia('(max-width: 1024px)').matches) {
        this.searchCurrentLocation()
      }
    })
  }

  mapAPIisReady () {
    return new Promise((resolve) => {
      window.resolveGoogleMapsPromise = () => {
        resolve(window.google)
        delete window.resolveGoogleMapsPromise
      }
      
      const src = `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_API_KEY}&v=3.34&&libraries=geometry&region=CA&callback=resolveGoogleMapsPromise&language=${this.lang}`
      const scriptAlreadyExists = document.querySelector(`script[src="${src}"]`)

      if (scriptAlreadyExists) {
        window.resolveGoogleMapsPromise()
      } else {
        const script = document.createElement("script")
        script.src = src
        script.async = true
        document.body.appendChild(script)
      }
    })
  }

  searchCurrentLocation () {
    this.setState({
      searchEnabled: true
    })

    const search = function (pos) {
      this.setState({
        isSearching: true
      })
      
      const latLng = new this.state.google.maps.LatLng({
        lat: parseFloat(pos.coords.latitude),
        lng: parseFloat(pos.coords.longitude)
      })

      this.calculateDistance(latLng, () => {
        this.setState({
          searchResult: {
            bounds: null,
            latLng,
            error: ''
          },
          isSearching: false
        })
      })
    }.bind(this)

    const onError = function () {
      this.setState({
        searchResult: {
          bounds: null,
          latLng: null,
          error: 'CURRENT_LOCATION_NOT_FOUND'
        }
      })
    }.bind(this)

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(search, onError)
    } else {
      this.setState({
        searchResult: {
          bounds: null,
          latLng: null,
          error: 'CURRENT_LOCATION_NOT_FOUND'
        }
      })
    }
  }

  searchLocation (val) {
    this.setState({
      isSearching: true,
      searchEnabled: false
    })

    const params = {
      'address': val,
      'componentRestrictions': {
        'country': 'CA'
      }
    }

    this.geocoder.geocode(params, (results, status) => {
      if(status === this.state.google.maps.GeocoderStatus.OK && results[0].formatted_address !== 'Canada') {
        this.calculateDistance(results[0].geometry.location, () => {
          this.setState({
            searchResult: {
              bounds: results[0].geometry.viewport,
              latLng: results[0].geometry.location,
              error: ''
            },
            isSearching: false
          })
        })
      } else {
        this.setState({
          searchResult: {
            bounds: null,
            latLng: null,
            error: 'NOT_FOUND'
          },
          isSearching: false
        })
      }
    })
  }

  calculateDistance(latLng, callback) {
    const storesWithDistance = this.state.allStores.map(store => {
      const storeLatLng = new this.state.google.maps.LatLng({lat: store.latitude, lng: store.longitude})
      const distance = this.state.google.maps.geometry.spherical.computeDistanceBetween(latLng, storeLatLng)

      store.distance = {
        val: parseFloat(distance/1000).toFixed(1),
        from: {
          lat: latLng.lat(),
          lng: latLng.lng()
        }
      }

      return store
    })

    this.setState({
      allStores: storesWithDistance
    }, callback)
  }

  updateStores (stores) {
    this.setState({
      stores
    })
  }

  selectStore (storeID) {
    this.setState({
      selectedStore: storeID
    })
  }

  highlightStores (storeIDs) {
    this.setState({
      highlightedStores: storeIDs
    })
  }

  onSearchSubmit (val) {
    if (this.state.allStores.length > 0 && this.state.searchEnabled) {
      this.searchLocation(val)
    }
  }

  enableSearch () {
    this.setState({
      searchEnabled: true
    })
  }

  render () {
    return (
      <div className={`${styles['stores']} ${this.state.isAccessible ? 'is-accessible' : ``}`}>
        <div className={styles['map-container']}>
          {this.state.google &&
            <Map
              lang={this.lang}
              google={this.state.google}
              stores={this.state.allStores}
              searchResult={this.state.searchResult}
              updateStores={this.updateStores}
              selectStore={this.selectStore}
              selectedStore={this.state.selectedStore}
              highlightStores={this.highlightStores}
              highlightedStores={this.state.highlightedStores}
              enableSearch={this.enableSearch}
            />
          }
        </div>
        <div className={styles['stores__sidebar']}>
          <div className={styles['stores__search-wrapper']}>
            <div className={styles['stores__search']}>
              <div className={styles['stores__search__title']}>{copy.searchInput.title[this.lang]}</div>
              <div className={styles['stores__search__sub-title']}>{copy.searchInput.subTitle[this.lang]}</div>
                <SearchInput
                  lang={this.lang}
                  location={this.props.location}
                  placeholder={copy.searchInput.placeholder[this.lang]}
                  buttonText={copy.searchInput.buttonText[this.lang]}
                  onIconClick={this.searchCurrentLocation}
                  onSubmit={this.onSearchSubmit}
                  enableSearch={this.enableSearch}/>
              <div className={styles['stores__search__details']}>
                {copy.searchInput.currentLocationText1[this.lang]}
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  <path d="M0 0h24v24H0z" fill="none"/>
                </svg>
                {copy.searchInput.currentLocationText2[this.lang]}
              </div>
            </div>
          </div>
          <StoreList
            lang={this.lang}
            loading={this.state.isSearching}
            searchResult={this.state.searchResult}
            stores={this.state.searchResult ? this.state.stores : null}
            selectStore={this.selectStore}
            highlightedStores={this.state.highlightedStores}
            highlightStores={this.highlightStores}/>
        </div> 
      </div>
    )
  }
}

export default Template
